import { render, staticRenderFns } from "./DialogCustomer.vue?vue&type=template&id=7ec3a4d4&"
import script from "./DialogCustomer.vue?vue&type=script&lang=ts&"
export * from "./DialogCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCustomer.vue?vue&type=style&index=0&id=7ec3a4d4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports